<div class="flex flex-col gap-y-2">
  @let vm = offshoreReportStore.vm();
  @if (vm.isSectionVisible('consumptions', 'fuelSpecs')) {
    <re-fuel-specs id="fuelSpecs" />
    <p-divider />
  }

  @if (vm.isSectionVisible('consumptions', 'totalConsumptions')) {
    <re-total-consumptions id="totalConsumptions" />
    <p-divider />
  }

  @if (vm.isSectionVisible('consumptions', 'auxEngineConsumptions')) {
    <re-aux-engine-consumptions id="auxEngineConsumptions" />
    <p-divider />
  }

  @if (vm.isSectionVisible('consumptions', 'boilerConsumptions')) {
    <re-boiler-consumptions id="boilerConsumptions" />
    <p-divider />
  }
  @if (vm.isSectionVisible('consumptions', 'water')) {
    <re-water id="water" />
    <p-divider />
  }
  @if (vm.isSectionVisible('consumptions', 'inertGasSystems')) {
    <re-inert-gas-systems id="inertGasSystems" />
    <p-divider />
  }
  @if (vm.isSectionVisible('consumptions', 'cylinderOilProduction')) {
    <re-cylinder-oil-production id="cylinderOilProduction" />
    <p-divider />
  }
  @if (consumptionsStore.dynamicSection()) {
    <re-dynamic-form
      tabId="consumptions"
      [events]="events"
      [formConfig]="
        offshoreReportStore.formConfig()?.tabs?.['consumptions']
          ?.customFields ?? []
      "
      [storeSectionState]="consumptionsStore.dynamicSection()"
      class="flex flex-col gap-y-2"
    ></re-dynamic-form>
  }
</div>
